import React from "react";

interface BannerStarsIconProps {
  className?: string;
}

export default function BannerStarsIcon({ className }: BannerStarsIconProps) {
  return (
    <svg
      width="88"
      height="88"
      viewBox="0 0 88 88"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        d="M72 32L67 21L56 16L67 11L72 0L77 11L88 16L77 21L72 32ZM72 88L67 77L56 72L67 67L72 56L77 67L88 72L77 77L72 88ZM32 76L22 54L0 44L22 34L32 12L42 34L64 44L42 54L32 76ZM32 56.6L36 48L44.6 44L36 40L32 31.4L28 40L19.4 44L28 48L32 56.6Z"
        fill="#6B4C9A"
      />
    </svg>
  );
}

